import { action, makeObservable, observable } from 'mobx';
import { oddStore } from './index';

class RoundTimeStore {
  timeData = {};

  isFinishTimeByGameType = {};

  constructor() {
    makeObservable(this, {
      timeData: observable.deep,
      isFinishTimeByGameType: observable.deep,
      setTime: action.bound,
      setIsFinishTime: action.bound,
    });
  }

  setIsFinishTime(bool, gameTypeId) {
    this.isFinishTimeByGameType[gameTypeId] = bool;
  }

  setTime(time, gameTypeId) {
    this.timeData[gameTypeId] = time;
    if (time !== null) {
      if (!this.isFinishTimeByGameType[gameTypeId]) {
        this.setIsFinishTime(true, gameTypeId);
      }
      setTimeout(() => {
        oddStore.setOddData(1, gameTypeId);
      }, 500);
    } else {
      this.setIsFinishTime(false, gameTypeId);
    }
  }
}

export const roundTimeStore = new RoundTimeStore();
